import { DaymapQuery as o } from "../../daymapQuery.js";
var t;
((a) => {
  class s extends o {
    constructor(n) {
      super(
        ["annotations", n.fileId],
        n,
        `/lms/api/assessment/annotations/${n.fileId}`,
        null,
        { stale: 1e3 }
        // 1 minute
      );
    }
  }
  a.Annotations = s;
})(t || (t = {}));
export {
  t as annotations
};
//# sourceMappingURL=index.js.map
